/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

 document.addEventListener('DOMContentLoaded', function() {
  const sizeSelectors = document.querySelectorAll(
    '.selector-wrapper[data-option-position="1"]'
  );

  sizeSelectors.forEach(function(wrapper) {
    const list = wrapper.querySelector('.select-popout__list[data-popout-list]');
    const input = wrapper.querySelector('[data-popout-input]');
    const toggleText = wrapper.querySelector('[data-popout-toggle-text]');

    if (!list || !input || !toggleText) return;

    const items = Array.from(list.querySelectorAll('.select-popout__item'));
    if (!items.length) return;

    // Sort items smallest → largest
    const sortedItems = items.sort(function(a, b) {
      return getSizeSortValue(a) - getSizeSortValue(b);
    });

    // Re-render list
    sortedItems.forEach(function(item) {
      list.appendChild(item);
      item.classList.remove('is-active');
      const link = item.querySelector('.select-popout__option');
      if (link) link.removeAttribute('aria-current');
    });

    // Pick the smallest (first sorted item)
    const firstItem = sortedItems[0];
    const firstValue = firstItem.querySelector('[data-popout-option]').dataset.value;

    // Mark as active
    firstItem.classList.add('is-active');
    const firstLink = firstItem.querySelector('.select-popout__option');
    if (firstLink) firstLink.setAttribute('aria-current', 'true');

    // Update hidden input + visible text
    input.value = firstValue;
    toggleText.textContent = firstValue;
  });

  function getSizeSortValue(item) {
    const text = item.textContent.trim();

    // 1) Use "cm" value if present
    const cmMatch = text.match(/(\d+(?:\.\d+)?)\s*cm/i);
    if (cmMatch) return parseFloat(cmMatch[1]);

    // 2) "Newborn" = smallest possible
    if (/newborn/i.test(text)) return 0;

    // 3) Use "Size X" number
    const sizeMatch = text.match(/Size\s+(\d+)/i);
    if (sizeMatch) return parseInt(sizeMatch[1], 10);

    return Number.MAX_SAFE_INTEGER;
  }
});

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();